import { Component, Input } from '@angular/core';
import { IconComponent, IconSize } from '../../../../shared/icons/icon.component';
import { PowerSource } from '@birco/rainmesh-api';
import { TextWithIconComponent } from '../../../../shared/components/text-with-icon/text-with-icon.component';
import { LocalizedPercentPipe } from '../../../../shared/pipes/localized-percent.pipe';

@Component({
  selector: 'app-power-item',
  imports: [IconComponent, TextWithIconComponent, LocalizedPercentPipe],
  templateUrl: './power-item.component.html',
  styleUrl: './power-item.component.scss',
})
export class PowerItemComponent {
  @Input() powerSource?: PowerSource;
  @Input() batteryLevel?: number;
  @Input() size: IconSize = IconSize.MD;

  protected readonly PowerSource = PowerSource;
}
